import Signals from '../signals/Signals';
export function createErrorResponse(component, error) {
    try {
        var errors = error.error.response.body.errors;
        component.setState({ errors: errors, submitting: false });
    }
    catch (err) {
        component.setState({ submitting: false });
        Signals.ShowNotification.dispatch('Er is iets misgegaan: ' + error.error.message, 'danger');
    }
}
/**
 *
 * @param errors
 * @param fieldName
 * @param intl
 * @return {undefined}
 */
export function extractErrorMessage(errors, fieldName, intl) {
    if (!errors)
        return undefined;
    var message = undefined;
    if (errors[fieldName]) {
        errors[fieldName].forEach(function (error) {
            var errorMessage = intl ? intl.formatMessage({ id: error }) : error;
            if (!message) {
                message = !message ? errorMessage : ', ' + errorMessage;
            }
        });
        //remove
        errors[fieldName] = null;
    }
    return message;
}
/**
 *
 * @param state
 * @param intl
 * @param suppress
 */
export function notifyUncaughtErrors(state, intl, suppress) {
    var errors = state.errors;
    var keys = errors ? Object.keys(errors) : [];
    var suppressKeys = suppress ? suppress : [];
    var message = '';
    keys.map(function (key) {
        if (!suppressKeys.includes(key)) {
            message += message.length > 0 ? ', ' : '';
            var msg = extractErrorMessage(errors, key, intl);
            message += msg ? key + ': ' + msg : '';
        }
    });
    if (message.length > 0 && keys.length > 0) {
        Signals.ShowNotification.dispatch(message, 'danger');
    }
    state.errors = [];
}
/**
 *
 * @param errors
 * @param fieldName
 * @return {boolean}
 */
export function hasError(errors, fieldName) {
    if (!errors)
        return false;
    if (!errors.forEach)
        return false;
    var hasError = false;
    errors.forEach(function (error) {
        if (error && error.length > 0 && error[0] === fieldName) {
            hasError = true;
        }
    });
    return hasError;
}
/**
 * Handle API errors in functional components
 * @param handler Object containing setState functions for errors and optionally submitting
 * @param error The error from the API call
 */
export function handleApiError(handler, error) {
    var _a, _b, _c, _d, _e;
    try {
        var errors = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.errors;
        if (errors) {
            handler.setErrors(errors);
        }
        else {
            handler.setErrors(null);
            var message = ((_d = error === null || error === void 0 ? void 0 : error.error) === null || _d === void 0 ? void 0 : _d.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Unknown error';
            Signals.ShowNotification.dispatch('Er is iets misgegaan: ' + message, 'danger');
        }
    }
    catch (err) {
        handler.setErrors(null);
        var message = ((_e = error === null || error === void 0 ? void 0 : error.error) === null || _e === void 0 ? void 0 : _e.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Unknown error';
        Signals.ShowNotification.dispatch('Er is iets misgegaan: ' + message, 'danger');
    }
    if (handler.setSubmitting) {
        handler.setSubmitting(false);
    }
}
